import { Loader3D, LoaderAssetRetryTypes, LoaderAudio, LoaderTextures } from './';
import { THREE, errorManager } from '@powerplay/common';
export class Loader {
    loadingManager = new THREE.LoadingManager();
    #assetsLoaders;
    onLoadedAllAssetsCallback;
    assetsLoadRetryCounter = new Map();
    errorTimeoutsIDs = new Map();
    TOTAL_ASSETS_TO_LOAD = 0;
    allAssetsLoaded = false;
    preloadersDone = 0;
    readyToLoad = false;
    constructor(WEBP_AVAILABLE, renderer) {
        this.#assetsLoaders = {
            a3d: new Loader3D(this.loadingManager, this.onPreloadComplete),
            textures: new LoaderTextures(this.loadingManager, WEBP_AVAILABLE, renderer, this.onCompleteLoading, this.onPreloadComplete),
            audio: new LoaderAudio()
        };
    }
    get assetsLoaders() {
        return this.#assetsLoaders;
    }
    getAssetsLoaded() {
        const { a3d, textures } = this.assetsLoaders;
        return a3d.assetsLoaded + textures.assetsLoaded;
    }
    init(modelsToLoad, texturesToLoad, audioToLoad) {
        this.#assetsLoaders.textures.initializeKTX2Loader();
        const { a3d, textures, audio } = this.assetsLoaders;
        audio.audioArrToLoad = audioToLoad;
        a3d.setData(modelsToLoad);
        textures.setData(texturesToLoad);
        this.TOTAL_ASSETS_TO_LOAD = Object.entries(modelsToLoad).length +
            Object.entries(texturesToLoad).length;
    }
    loadAll(callback, callbackAddAudio) {
        this.assetsLoaders.audio.loadAllAudio(callbackAddAudio);
        this.onLoadedAllAssetsCallback = callback;
        this.loadingManager.onStart = this.onStartLoading;
        this.loadingManager.onLoad = this.onCompleteLoading;
        this.loadingManager.onProgress = this.onProgressLoading;
        this.loadingManager.onError = this.onErrorLoading;
        const { a3d, textures } = this.assetsLoaders;
        a3d.loadAllAssets(this.beforeLoadAsset);
        textures.loadAllAssets(this.beforeLoadAsset);
    }
    onStartLoading = (file) => {
        console.log(file);
        return file;
    };
    onProgressLoading = (file) => {
        const percent = Math.round((this.getAssetsLoaded() / this.TOTAL_ASSETS_TO_LOAD) * 90);
        console.log(file, percent);
        return percent;
    };
    getAssetDataByUrl = (url) => {
        const { a3d, textures } = this.assetsLoaders;
        const a3dData = a3d.assetsUrls.filter(value => value.url === url);
        if (a3dData.length > 0)
            return a3dData[0];
        const texturesData = textures.assetsUrls.filter(value => value.url === url);
        if (texturesData.length > 0)
            return texturesData[0];
        throw new Error(errorManager.showBox(`No retry data for this url! (${url})`));
    };
    onErrorLoading = (url) => {
        const assetData = this.getAssetDataByUrl(url);
        console.log(`There was an error loading ${url}, assetName: ${assetData.name}`);
        const timeoutError = this.errorTimeoutsIDs.get(assetData.name) || 0;
        let counter = this.assetsLoadRetryCounter.get(assetData.name) || 0;
        if (timeoutError)
            return;
        counter += 1;
        this.assetsLoadRetryCounter.set(assetData.name, counter);
        if (counter <= 3) {
            this.retryLoadFile(assetData);
        }
        else {
            throw new Error(errorManager.showBox(`We could not download all assets! (${url})`));
        }
    };
    onCompleteLoading = () => {
        console.log(`Loading complete? ${this.getAssetsLoaded()} / ${this.TOTAL_ASSETS_TO_LOAD}`);
        if (this.getAssetsLoaded() === this.TOTAL_ASSETS_TO_LOAD && !this.allAssetsLoaded) {
            this.allAssetsLoaded = true;
            this.onLoadedAllAssetsCallback();
        }
    };
    onPreloadComplete = () => {
        this.preloadersDone++;
        if (this.preloadersDone < 2)
            return;
        console.log('Preload complete');
        this.readyToLoad = true;
    };
    retryLoadFile = (data) => {
        console.log(`ideme robit retry suboru ${data.name}`);
        const errorTimeoutID = window.setTimeout(() => {
            this.errorTimeoutsIDs.set(data.name, 0);
            const { a3d, textures } = this.assetsLoaders;
            if (data.type === LoaderAssetRetryTypes.a3d) {
                a3d.loadAsset(data.name);
            }
            else {
                textures.loadAsset(data.name);
            }
        }, 5000);
        console.log(`errro file ${data.name} -> retry in 5 seconds ${errorTimeoutID}`);
        this.errorTimeoutsIDs.set(data.name, errorTimeoutID);
        return errorTimeoutID;
    };
    beforeLoadAsset = (assetName) => {
        this.errorTimeoutsIDs.set(assetName, 0);
        if (!this.assetsLoadRetryCounter.get(assetName)) {
            this.assetsLoadRetryCounter.set(assetName, 0);
        }
    };
}
//# sourceMappingURL=Loader.js.map